import styled from 'styled-components';
import { rem } from '../../utils';
export const StyledWrapper = styled.div `
  width: 100%;
  margin: ${({ theme }) => rem(theme.Spacing.Size.XXSmall)};
  border-bottom: ${({ theme }) => `${rem(theme.Border.Size.Small)} solid ${theme.Components.Panel.Divider.Color}`};
`;
//# sourceMappingURL=Divider.style.js.map